import type { User } from '@/shared/types'

export interface AuthTokenResponse {
  access_token: string
  token_type: string
  expires_in: number
  user: User
}

export interface TwoFactorChallengeResponse {
  two_factor_required: true
  challenge_id: string
  expires_in: number
  masked_email: string
}

export type LoginResponse = AuthTokenResponse | TwoFactorChallengeResponse

export function isTwoFactorChallenge(res: LoginResponse): res is TwoFactorChallengeResponse {
  return 'two_factor_required' in res && res.two_factor_required === true
}
